import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import Search from './common/Search';
import Sidebar from './common/Sidebar';
import StickyMenu from './common/StickyMenu';
import MobileMenu from './common/MobileMenu';
import { Styles } from "./styles/headerTwo.js";

class HeaderTwo extends Component {
    render() {
        return (
            <Styles>
                {/* Topbar 2 */}
                <section className="top-bar2">
                    <Container className="px-0">
                        <Row>
                            <Col lg="8" md="8">
                                <div className="bar-left">
                                    <ul className="list-unstyled list-inline">
                                        <li className="list-inline-item"><i className="las la-phone"></i>+91 7599020021</li>
                                        <li className="list-inline-item"><i className="las la-envelope"></i>info@erptechpro.in</li>
                                        <li className="list-inline-item"><i className="las la-map-marker"></i>Near Golden Future Library, Roorkee</li>
                                    </ul>
                                </div>
                            </Col>
                            <Col lg="4" md="4">
                                <div className="bar-right d-flex justify-content-end">
                                    {/* <ul className="list-unstyled list-inline bar-lang">
                                        <li className="list-inline-item">
                                            <Dropdown>
                                                <Dropdown.Toggle>
                                                    <img src="/assets/images/us.png" alt="" />English
                                                    <i className="las la-angle-down"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu as="ul">
                                                    <Dropdown.Item as="li"><img src="/assets/images/us.png" alt="" /> English</Dropdown.Item>
                                                    <Dropdown.Item as="li"><img src="/assets/images/fra.png" alt="" /> French</Dropdown.Item>
                                                    <Dropdown.Item as="li"><img src="/assets/images/ger.png" alt="" /> German</Dropdown.Item>
                                                    <Dropdown.Item as="li"><img src="/assets/images/spa.png" alt="" /> Spanish</Dropdown.Item>
                                                    <Dropdown.Item as="li"><img src="/assets/images/bra.png" alt="" /> Brazilian</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </li>
                                    </ul> */}
                                    <ul className="list-unstyled list-inline ">
                                        <li className="nav-item"
                                            style={{
                                                backgroundColor: "#11B67A",
                                                marginRight: "10px",
                                                borderRadius: "8px",
                                            }}><Link className="nav-link" to="/login" style={{ color: "white" }}>Log In</Link></li>

                                    </ul>

                                    <ul className="list-unstyled list-inline bar-social">
                                        <li className="list-inline-item"><a href="https://www.facebook.com/61580941010197/"><i className="fab fa-facebook-f"></i></a></li>
                                        <li className="list-inline-item"><a  href="https://wa.me/917599020021"><i className="fab fa-whatsapp"></i></a></li>
                                        <li className="list-inline-item"><a href="https://youtube.com/@erptechpro?si=nhu16ox6xv46Kdx9"><i className="fab fa-youtube"></i></a></li>
                                        <li className="list-inline-item"><a href="https://www.instagram.com/erptechproofficial?igsh=MTN2NG9xbmJ0MTY1dg=="><i className="fab fa-instagram"></i></a></li>
                                    </ul>

                                    <ul className="list-unstyled list-inline sidebar-button">
                                        <li className="list-inline-item nav-item side-box">
                                            <Sidebar />
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Logo Area 2 */}
                <section className="logo-area2">
                    <Container>
                        <Row>
                            <Col md="2" className="px-0">
                                <div className="logo">
                                    <Link to="/"><img src="/assets/images/logo2.png" alt="Care University of Education" /></Link>
                                </div>
                            </Col>

                            <Col md="10" className="px-0">
                                <div className="menu-box d-flex justify-content-end">
                                    <ul className="nav menu-nav">

                                        <li className="nav-item active">
                                            <Link className="nav-link" to="/">
                                                Home
                                            </Link>
                                        </li>
                                        <li className="nav-item active">
                                            <Link className="nav-link" to="/about">About Us</Link>
                                        </li>
                                        <li className="nav-item active ">
                                            <Link className="nav-link" to="/gallery">Gallery</Link>
                                        </li>




                                        {/* <li className="nav-item dropdown">
                                            <Link className="nav-link dropdown-toggle" to="/" data-toggle="dropdown">
                                                Pages <i className="las la-angle-down"></i>
                                            </Link>
                                            <ul className="dropdown list-unstyled">
                                                <li className="nav-item"><Link className="nav-link" to="/registration">Registration</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="/faq">Faq</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="/404">404</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="/coming-soon">Coming Soon</Link></li>
                                            </ul>
                                        </li> */}
                                        <li className="nav-item active">
                                            <Link className="nav-link" to="/course-grid">
                                                Courses
                                            </Link>
                                        </li>
                                        {/* <li className="nav-item dropdown">
                                            <Link className="nav-link dropdown-toggle" to="/" data-toggle="dropdown">
                                                Courses <i className="las la-angle-down"></i>
                                            </Link>
                                            <ul className="dropdown list-unstyled">
                                                <li className="nav-item"><Link className="nav-link" to="/course-grid">Course Grid</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="/course-list">Course List</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="/course-details">Course Details</Link></li>
                                            </ul>
                                        </li> */}

                                        <li className="nav-item active">
                                            <Link className="nav-link" to="/instructor">
                                                Instructors
                                            </Link>
                                        </li>

                                        {/* <li className="nav-item dropdown">
                                            <Link className="nav-link dropdown-toggle" to="/" data-toggle="dropdown">
                                                Instructor <i className="las la-angle-down"></i>
                                            </Link>
                                            <ul className="dropdown list-unstyled">
                                                <li className="nav-item"><Link className="nav-link" to="/instructor">Instructors</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="/instructor-details">Instructor Details</Link></li>
                                            </ul>
                                        </li> */}

                                        <li className="nav-item active">
                                            <Link className="nav-link" to="/events">
                                                Events
                                            </Link>
                                        </li>

                                        {/* <li className="nav-item dropdown">
                                            <Link className="nav-link dropdown-toggle" to="/" data-toggle="dropdown">
                                                Event <i className="las la-angle-down"></i>
                                            </Link>
                                            <ul className="dropdown list-unstyled">
                                                <li className="nav-item"><Link className="nav-link" to="/events">Events</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="/event-details">Event Details</Link></li>
                                            </ul>
                                        </li> */}

                                        <li className="nav-item active">
                                            <Link className="nav-link" to="/blog-grid">
                                                Blogs
                                            </Link>
                                        </li>

                                        {/* <li className="nav-item dropdown">
                                            <Link className="nav-link dropdown-toggle" to="/" data-toggle="dropdown">
                                                Blog <i className="las la-angle-down"></i>
                                            </Link>
                                            <ul className="dropdown list-unstyled">
                                                <li className="nav-item"><Link className="nav-link" to="/blog-classic">Blog Classic</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="/blog-grid">Blog Grid</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="/blog-details">Blog Details</Link></li>
                                            </ul>
                                        </li> */}
                                        <li className="nav-item active">
                                            <Link className="nav-link" to="/contact">Contact</Link>
                                        </li>

                                    </ul>

                                    {/* <div className="search-box">
                                        <Search />
                                    </div> */}

                                    <div className="apply-btn">
                                        <Link to="/registration">
                                            Apply Now
                                        </Link>
                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Sticky Menu */}
                <StickyMenu />

                {/* Mobile Menu */}
                <MobileMenu />
            </Styles>
        )
    }
}

export default HeaderTwo
